import { post } from '@/request';

const majorNewsApi = {
  list(data) {
    return post('/gt/majorNews/zlb/list', data);
  },
  one(data) {
    return post('/gt/majorNews/zlb/one', data);
  }
};
export default majorNewsApi;
